import { useQuery } from '@tanstack/react-query'
import api from '../lib/api'

export interface MentionableUser {
  id: number
  name: string
  email: string
  role: string
}

/**
 * `enabled` gates the fetch to viewers who can open a people-picking UI.
 * A read-only viewer renders names from data already on the demand
 * (PersonPicker's `currentName`), so fetching the directory for them was
 * pure overhead — and the reason every signed-in talent pulled the council
 * list on page load (#1153). Defaults to true for call sites that are
 * themselves behind a council-only gate (e.g. the Timeline tab).
 */
export function useMentionableUsers(
  focusAreaCode: string | undefined | null,
  enabled: boolean = true,
) {
  return useQuery<MentionableUser[]>({
    queryKey: ['mentionable-users', focusAreaCode],
    queryFn: async () => {
      const res = await api.get<MentionableUser[]>('/users/mentionable', {
        params: { focus_area_code: focusAreaCode },
      })
      return res.data
    },
    enabled: !!focusAreaCode && enabled,
    staleTime: 5 * 60 * 1000,
  })
}
